<app-warning-message *ngIf="show === true">

    <div class="warning flex flex-row justify-between">

        <div class="warning__text flex-auto">
            {{ message }}
        </div>

        <div>
            <div class="warning__close flex justify-center" (click)="handleDismissClick()">
                <app-icon
                    icon="times"
                    size="lg"
                    title="Close">
                </app-icon>
            </div>
        </div>

    </div>
    
</app-warning-message>